import React from 'react';

const Customer = React.lazy(() => import('./Customer'));
const ViewCustomer = React.lazy(() => import('./ViewCustomer'));

export const customerRouteConfigs = [
  {
    path: '/customer',
    element: <Customer />,
  },
  {
    path: '/customer/:id',
    element: <ViewCustomer />,
  },
];
